var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5717 24.9339L39.6242 13.5H37.2424L28.5099 23.4258L21.5404 13.5H13.5L24.0416 28.5109L13.5 40.5H15.8818L25.0978 30.0156L32.4596 40.5H40.5L29.5717 24.9339ZM26.3085 28.6427L25.2387 27.147L16.7407 15.257H20.3996L27.2598 24.8562L28.325 26.3518L37.2412 38.8286H33.5823L26.3085 28.6427Z",
    fill: "#0F1419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.27439512c8cf198ef117f454f0a9e585.svg";
export { ForwardRef as ReactComponent };